import { ButtonProps, Button as AntButton } from 'antd';
import React from 'react';
import './button.module.less';

const Button: React.FC<ButtonProps> = ({ children, ...props }: ButtonProps) => {
  return <AntButton {...props}>{children} </AntButton>;
};

export { Button };
